var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dateButtonBody",staticStyle:{},on:{"click":_vm.dateClick}},[_vm._v(" "+_vm._s(_vm.name)),_c('span',[_vm._v(_vm._s(_vm.date)),_c('img',{attrs:{"src":_vm.getResourcesByName('wedoButton/date.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }